import script from "./Iframesy.vue?vue&type=script&setup=true&lang=js"
export * from "./Iframesy.vue?vue&type=script&setup=true&lang=js"

import "./Iframesy.vue?vue&type=style&index=0&id=36357110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36357110"]])

export default __exports__